// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"61eea728","446":"82c3961d","460":"84362f36","488":"22b449f6","551":"31fb7215","571":"f0a8d561","728":"14c2cf5f","730":"11ca7784","880":"9bf8962c","913":"dee6a4e8","969":"6c7242f3","979":"2b77a860"}[chunkId] + ".chunk.js";
};